import yaml from 'yaml'
import formatYAML, {DefaultOptions} from '../../CodeFormatters/YAMLFormatter/formatYAML'

/**
 * 將 JSON 轉為 YAML
 * @param {string} input
 * @param {object} options
 * @returns {Promise<string>} output
 */
export default async function convertJSONToYAML(input, options={}) {
  try {
    const object = JSON.parse(input)
    const result = yaml.stringify(object)
    return formatYAML(result, {...DefaultOptions, ...options})
  } catch (e) {
    throw new Error('Invalid JSON')
  }
}
